import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import { BackEndService } from 'src/app/backend-service';
import { Calendar, CalendarEntry } from 'src/app/classes';
import { AbstractWidgetInner } from 'src/app/widget-inner';
import { SelectCalendarViewComponent } from '../../../dialog-components/select-calendar-view/select-calendar-view.component';

@Component({
  selector: 'app-calendar-widget-inner',
  templateUrl: './calendar-widget-inner.component.html',
  styleUrls: ['./calendar-widget-inner.component.css']
})
export class CalendarWidgetInnerComponent extends AbstractWidgetInner {

  _body: ElementRef;
  @ViewChild("body", { static: true }) set body(ref: ElementRef){
    this._body = ref;
    setTimeout(() => this.setCalendarSize(), 1);
  }
  get body(): ElementRef {
    return this._body;
  }

  @ViewChild("calendar") calendarComponent: FullCalendarComponent;

  calendarOptions: CalendarOptions = {
    locale: 'de',
    initialView: CalendarViews.DayGridMonth,
    firstDay: 1,
    buttonText: {
      today: "Heute"
    },
    eventClick: this.eventClick.bind(this),
    dateClick: this.dateClick.bind(this),
    dayCellClassNames: "calendar-cell",
    customButtons: {
      viewChooser: {
        text: 'Ansicht',
        click: () => this.openViewChooser()
      }
    },
    headerToolbar: {
      left: 'title',
      center: '',
      right: 'today prev,next viewChooser'
    }
  };

  calendarEntriesLoaded: Calendar[] = [];
  calendars: Calendar[];
  calendarsVisible: Calendar[] = [];

  constructor(
    private _backEndService: BackEndService,
    private _dialog: MatDialog
  ) {
    super();
    this._backEndService.get("api/nextcloud/calendar").subscribe((calendars: Calendar[]) => {
      this.calendars = calendars.filter(x => typeof (x.name) === 'string');
      this.calendarsVisible = this.calendars;
      /*
      let views: WidgetInnerView[] = [];
      for (let calendar of this.calendars) {
        this._backEndService.post("api/nextcloud/calendar/content", {
          path: calendar.href
        } as NextcloudSearchRequest).subscribe((result: CalendarEntry[]) => {
          calendar.entries = result;
          this.calendarEntriesLoaded.push(calendar);
          this.fillCalendarIfAllEntriesLoaded();
        });
        let view = new WidgetInnerView();
        view.color = calendar.color;
        view.icon = "today";
        view.name = calendar.name;
        this.viewSubscriptions.push(view.onClick.subscribe(() => this.toggleCalendar(calendar)));
        views.push(view);
      }
      
      this.data.subject.next(views);
      */
    });
  }

  dateClick(data: any){
    /*
    this.viewSubscriptions.push(this._dialog.open(AddEventComponent, {
      data: {
        date: data.date,
        calendars: this.calendars
      } as AddEventComponentInputData,
      panelClass: 'no-padding-dialog-container',
      autoFocus: false
    }).afterClosed().subscribe((result: CalendarEntry) => {
      if(result){
        result.calendar.entries.push(result);
        this.fillCalendar();
      }
    }));
    */
  }

  eventClick(data: any) {
    let fullCalendarEvent: FullCalendarEvent = data.event;
    let event: CalendarEntry;
    for (let calendar of this.calendars) {
      for (let entry of calendar.entries) if (entry.id === fullCalendarEvent.id) {
        event = entry;
        continue;
      }
      if (event) continue;
    }
    if (event) {
      /*
      this._dialog.open(EditEventComponent, {
        panelClass: "no-padding-dialog-container",
        autoFocus: false,
        data: event
      }).afterClosed().subscribe((event: CalendarEntry) => {
        console.log(event);
      });
      */
    }
  }

  fillCalendar(){
    let eventArray = [];
    for (let calendar of this.calendars) {
      if (!Array.isArray(calendar.entries)) continue;
      let i = this.calendarsVisible.indexOf(calendar);
      if(i == -1) continue;
      for (let event of calendar.entries) eventArray.push({
        "id": event.id,
        "start": event.start,
        "end": event.end,
        "title": event.title,
        "backgroundColor": calendar.color
      } as FullCalendarEvent);
    }
    this.calendarOptions.events = eventArray;
  }

  fillCalendarIfAllEntriesLoaded() {
    if (this.calendars.some(x => (this.calendarEntriesLoaded.indexOf(x) > -1))) this.fillCalendar();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setCalendarSize();
  }

  openViewChooser() {
    this._dialog.open(SelectCalendarViewComponent, {
      panelClass: "no-padding-dialog-container", data: this.calendarComponent.getApi().view.type
    }).afterClosed().subscribe((result: string) => {
      if (result) {
        this.calendarComponent.getApi().changeView(result);
      }
    });
  }

  setCalendarSize() {
    let height = (this.body.nativeElement as HTMLDivElement).clientHeight - 20;
    this.calendarOptions.height = height;
  }

  toggleCalendar(calendar: Calendar) {
    let i = this.calendarsVisible.indexOf(calendar);
    if (i > -1) this.calendarsVisible.splice(i, 1);
    else this.calendarsVisible.push(calendar);
    this.fillCalendar();
  }

}

class FullCalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  backgroundColor: string;
  allDay: boolean;
}

export const CalendarViews = {
  "ListWeek": "listWeek",
  "TimeGridWeek": "timeGridWeek",
  "DayGridMonth": "dayGridMonth",
  "DayGridWeek": "dayGridWeek"
}